module.exports = __webpack_public_path__ + "static/img/icon-shop-order-logistics.4291d528.png";